/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { colors } from "../../../../components/colors";
import { SmallBadge } from "../../../../components/SmallBadge";
import { AutoCampaignListItem } from "../models/AutoCampaign";
import { StyledText } from "../../../../assets/typography/typography";

type Props = {
  discountType: AutoCampaignListItem["discountType"];
};

const getDiscountTypeName = (
  discountType: AutoCampaignListItem["discountType"]
) => {
  switch (discountType) {
    case "percentage_discount":
      return "Percentage discount";
    case "fixed_price":
      return "Fixed price";
    default:
      return discountType;
  }
};

export const DiscountTypeBadge = ({ discountType }: Props) => {
  const badgeAdditionalStyles = css`
    color: ${discountType === "fixed_price"
      ? colors.blueDark
      : colors.organgeDark};
  `;

  return (
    <SmallBadge
      additionalStyles={badgeAdditionalStyles}
      backgroundColor={
        discountType === "fixed_price" ? colors.blueLight : colors.orangeLight
      }
      borderColor={
        discountType === "fixed_price" ? colors.blueMedium : colors.orangeMedium
      }
    >
      <StyledText className="bodyTextRegular mb-0">
        {getDiscountTypeName(discountType)}
      </StyledText>
    </SmallBadge>
  );
};
